import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { UserService } from '../services/user.service';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const userService = inject(UserService);
  const requiredRoles: string[] = route.data['roles'] ?? [];

  if (!requiredRoles.length) {
    return true;
  }

  if (!localStorage.getItem(environment.accessTokenName)) {
    router.navigate(['/login']);
    return false;
  }

  const user = route.parent?.data['user'];
  if (user) {
    const hasRole = user.roles.some((r: string) => requiredRoles.includes(r));
    if (!hasRole) {
      router.navigate(['/unauthorized']);
    }
    return hasRole;
  }

  return userService.getCurrentUser().pipe(
    map((response) => {
      const hasRole = response.roles.some((r: string) => requiredRoles.includes(r));
      if (!hasRole) {
        router.navigate(['/unauthorized']);
      }
      return hasRole;
    })
  );
};
